<template>
    <div class="row page-row site-tools">

        <div class="users-page-header col-12"><div class="col-4">
            Tool count: <span class="">{{ tools.length }} / 6</span></div>
        </div>

        <div class="col-sm-12">
            <br/>
                <b-button ref="btnShow" class="mr-1" :disabled="!hasManagerPermission('site_tools.edit') || tools.length > 5" variant="danger" @click="newTool">
                    CREATE NEW TOOL
                </b-button>

                <b-button ref="btnShow" :disabled="!hasManagerPermission('site_tools.edit') || tools.length > 5" variant="danger" @click="importTool">
                    IMPORT TOOLS FROM A DIFFERENT PROJECT
                </b-button>
            <br/>
            <br/>

            <table class="site-tools table">
                <thead>
                <tr>
                    <th scope="col">TOOL NAME</th>
                    <th scope="col">SHORT NAME</th>
                    <th scope="col">ICON</th>
                    <th scope="col">DESCRIPTION</th>
                    <th scope="col"></th>
                    <th scope="col">ACTIONS</th>
                    <th scope="col">PREVIEW</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="tool in tools" v-bind:key="tool.id">
                    <td scope="row" v-text="tool.long_name"></td>
                    <td scope="row">{{ tool.short_name.toUpperCase() }} (shows in app)</td>
                    <td>
                        <Icon
                            :bottom-text="tool.show_lower_detail ? (tool.icon === 'red-pen' ? tool.short_name.toUpperCase() + '_1' : tool.short_name.toUpperCase()) : (tool.icon === 'red-pen' ? '1' : '')"
                            :color="tool.color ? tool.color : '#000000'"
                            :height="50"
                            :middle-text="tool.show_running_number ? '1' : ''"
                            :tool-icon="tool.icon"
                            :tool-type="tool.type"
                            :top-text="tool.show_upper_detail ?  (tool.type === 'firestop' ? 'DET1' : tool.text_1)  : ''"
                            :width="50"
                        ></Icon>
                    </td>
                    <td width="20%" v-text="tool.description"></td>
                    <td v-text="tool.created_at"></td>
                    <td>
                        <button :disabled="!hasManagerPermission('site_tools.edit')" class="btn edit" type="button" @click="editTool(tool)"></button>
                        <button :disabled="!hasManagerPermission('site_tools.edit')" class="btn copy" type="button" @click="copyTool(tool)"></button>
                        <button :disabled="!hasManagerPermission('site_tools.delete')" class="btn delete" type="button"
                                @click="deleteTool(tool)"></button>
                    </td>
                    <td>
                        <button class="btn preview" type="button" @click="previewTool(tool)"></button>
                    </td>
                </tr>

                </tbody>
            </table>

            <ImportModal
                v-on:toolsImported="loadTools"
            ></ImportModal>


            <ToolModal :editTool="tool"
                       :step="step"
                       v-on:closeModal="tool = null"
                       v-on:jumpToStep="jumpToStep"
                       v-on:nextStep="step++"
                       v-on:previousStep="step--"
                       v-on:saveTool="saveTool"
            ></ToolModal>
        </div>
    </div>
</template>

<script>
import ToolModal from "./parts/ToolModal";
import ImportModal from "./parts/ImportModal";
import '@css/site-tools.scss';
import axios from "axios";
import Icon from "./parts/Icon";

export default {
    name: "SiteTools",
    components: {Icon, ToolModal, ImportModal},
    data() {
        return {
            tools: [],
            tool: {},
            step: 1,
            project: {id: null}

        }
    },
    watch: {
        'project.id': function () {
            this.loadTools();
        },
    },
    computed: {},
    mounted() {
        this.project = this.$store.state.project;
    },
    methods: {
        usedInProjects(projects) {
            return _.map(projects, 'name').join(', ');
        },
        newTool() {
            this.tool = null;
            this.step = 1;

            this.$bvModal.show('tool-modal');
        },
        importTool() {
            this.$bvModal.show('import-modal');
        },
        jumpToStep(step) {
            this.step = step;
        },
        loadTools() {

            if (this.project && this.project.id) {

                let token = this.$store.state.token;
                let url = this.$store.getters.apiProjectBase + '/marking-tools';
                let method = 'GET';

                axios({
                    url: url,
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.tools = response.data.data;
                    })
                    .catch(error => {
                        console.log('err', error);
                        alert('Unable to get project tools');
                    });
            }


        },
        saveTool(tool) {

            const token = this.$store.state.token;
            const url = this.$store.getters.apiProjectBase + '/marking-tools';
            const method = 'POST';

            if (tool.copy) {
                tool.id = null;
            }

            axios({
                url: url,
                data: tool,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(() => {
                    this.loadTools();
                    this.$bvModal.hide('tool-modal');
                })
                .catch(error => {
                    alert('Something went wrong');
                    console.log(error);
                });


        },
        deleteTool(tool) {

            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this tool?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Delete',
                cancelTitle: 'Cancel',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {

                    const token = this.$store.state.token;
                    const url = this.$store.getters.apiProjectBase + '/marking-tools/' + tool.id;
                    const method = 'DELETE';

                    axios({
                        url: url,
                        method: method,
                        headers: {"Authorization": "Bearer " + token}
                    })
                        .then(response => {
                            this.loadTools();
                        })
                        .catch(error => {
                            alert('Something went wrong');
                            console.log(error);
                        });
                }
            });


        },
        previewTool(tool) {
            this.tool = tool;
            this.jumpToStep(8);
            this.$bvModal.show('tool-modal');
        },
        editTool(tool) {
            this.tool = tool;
            this.jumpToStep(3);
            this.$bvModal.show('tool-modal');
        },
        copyTool(tool) {
            tool.copy = true;
            this.editTool(tool);
        }
    }
}
</script>
